import { Tab, Tabs, TabList, TabPanel } from 'components/common/tabs';
import 'components/common/tabs/style/react-tabs.scss';

import SearchInput from 'components/common/form/search-input/search-input';
import OngoingDelegationPoolsTable from 'components/delegation-table/ongoing-delegation-pools-table';
import CompletedDelegationPoolsTable from 'components/delegation-table/completed-delegation-pools-table';

const DelegatePage = () => {
  return (
    <Tabs>
      <TabList>
        <Tab>Ongoing Delegation Pools</Tab>
        <Tab>My Delegation Pools</Tab>
        <Tab>Completed Delegation Pools</Tab>
      </TabList>

      <SearchInput />

      <TabPanel>
        <OngoingDelegationPoolsTable />
      </TabPanel>
      <TabPanel>
        <h2>Tab 2</h2>
      </TabPanel>
      <TabPanel>
        <CompletedDelegationPoolsTable />
      </TabPanel>
    </Tabs>
  );
};

export default DelegatePage;
